import * as React from 'react';

function SvgTransfer(props) {
  return (
    <svg width={20} height={20} fill="none" {...props}>
      <path
        d="M8 7.56h9.122M13.89 10.793l3.232-3.232-3.232-3.233M12.122 13.561H3M6.232 10.329L3 13.56l3.232 3.233"
        stroke={props.color}
        strokeWidth={1.5}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

export default SvgTransfer;
